module.exports = __webpack_public_path__ + "img/support_bus.5c9fdc7e.png";